import { database } from "..";
import Customer from "../model/customer";
import Appointment from "../model/appointment";

export type APIAppointment = {
  id?: string;
  customerId: string;
  startTime: number;
  endTime: number;
  notes: string;
  createdAt?: number;
  updatedAt?: number;
};

export function emptyAppointment(): APIAppointment {
  const curTime = new Date()
  // remove some precision from time
  curTime.setMilliseconds(0)
  curTime.setSeconds(0)
  return {
    startTime: curTime.getTime(),
    endTime: curTime.getTime() + (1000 * 60 * 60 * 2), // set end time to 2 hours after by default
    notes: "",
    customerId: "",
  };
}

function dbAppointmentToAPIAppointment(appointment: Appointment): APIAppointment {
  return {
    id: appointment.id,
    customerId: appointment.customer?.id || "",
    startTime: appointment.startTime || 0,
    endTime: appointment.endTime || 0,
    notes: appointment.notes || "",
  };
}

export async function getAppointment(appointmentID?: string, customerId?:string): Promise<APIAppointment> {
  if (appointmentID === undefined) {
    const empty = emptyAppointment();
    return customerId ? {...empty, customerId} : empty
  }
  const appointment = await database.get<Appointment>("appointments").find(appointmentID);
  return dbAppointmentToAPIAppointment(appointment);
}

export async function saveAppointment(appointment: APIAppointment): Promise<APIAppointment> {
  const cr = await database
    .get<Customer>("customers")
    .find(appointment.customerId || "");
  const databaseWrite = (p: Appointment) => {
    const c: any = p.customer;
    c.set(cr);
    p.startTime = appointment.startTime;
    p.endTime = appointment.endTime;
    p.notes = appointment.notes;
  };
  let savedAppointmentID: string | undefined = appointment.id;
  if (!appointment.id) {
    await database.write(async () => {
      const savedAppointment = await database
        .get<Appointment>("appointments")
        .create(databaseWrite);
        savedAppointmentID = savedAppointment.id;
    });
  } else {
    await database.write(async () => {
      const savedAppointment = await database
        .get<Appointment>("appointments")
        .find(appointment.id || "");
      await savedAppointment.update(databaseWrite);
    });
  }
  return getAppointment(savedAppointmentID);
}

export async function getAllAppointments(): Promise<APIAppointment[]> {
  const appointmentCollection = database.get<Appointment>("appointments");
  let query = appointmentCollection.query();
  const dbAppointments: Appointment[] = await query.fetch();
  const appointments: APIAppointment[] = dbAppointments.map(dbAppointmentToAPIAppointment);
  return appointments;
}